import { connect, useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';
import AddLevels from './addLevel';
import { ontologyMasterActions } from '../../store/reducers/ontology-master';
import { Card, CircularProgress, Box, Typography, Select, MenuItem, Grid, Tooltip, IconButton, lighten, useMediaQuery, useTheme } from '@mui/material';
import { ReactComponent as MapMakerIcon } from '../../assets/icons/main/map-marker-icon.svg';
import { palette } from '../../theme/palette';
import { ReactComponent as VerticalLine } from '../../assets/icons/main/verticalLine.svg';
import { ReactComponent as ExpandMoreIcon} from '../../assets/icons/main/chevron-down-icon.svg';
import { ReactComponent as ExpandLessIcon} from '../../assets/icons/main/chevron-up-icon.svg';
import useNotification from '../../common/notification';
import get from 'lodash/get';
import AddButtonWithAccessCheck from '../../components/AddButtonWithAccessCheck';
import EditButtonWithAccessCheck from '../../components/EditButtonWithAccessCheck';
import { useOutletContext } from 'react-router-dom';
import chroma from 'chroma-js';

const Styles = {
  // root: {
  //   backgroundColor: '#f8fafb',
  //   height: '100vh',
  //   display: 'flex',
  //   justifyContent: 'center',
  //   alignItems: 'center',
  // },
  // title: {
  //   border: '1px solid red',
  //   position: 'absolute',
  //   display: 'flex',
  //   width: '317px',
  //   height: '38px',
  //   alignItems: 'left',
  //   fontFamily: 'Open Sans, sans serif',
  //   fontStyle: 'normal',
  //   fontWeight: 600,
  //   fontSize: '1.8rem',
  //   lineHeight: '38px',
  //   color: '#434D67',
  // },

  // icon: {
  //   display: 'flex',
  //   width: '60px',
  //   height: '60px',
  //   marginLeft: '10px',
  // },
  // circleIcon: {
  //   width: '42px',
  //   height: '42px',
  //   padding: '8px 9px 8px 8px',
  //   borderRadius: '50%',
  //   backgroundColor: palette.success.main,
  //   display: 'flex',
  //   justifyContent: 'center',
  //   alignItems: 'center',
  //   color: palette.primary.contrastText,
  // },
  // number: {
  //   fontFamily: 'Open Sans',
  //   fontSize: '1.6rem',
  //   fontWeight: 800,
  //   lineHeight: '27px',
  //   letterSpacing: '0em',
  //   textAlign: 'center',
  // },

  content: {
    display: 'contents',
    flexDirection: 'row',
    alignItems: 'center',
    gridGap: '20px',
  },

  // locationIcon: {
  //   width: '42px',
  //   height: '42px',
  // },
};

interface OntologyLevelTypes {
  isOntologyDataLoading: boolean;
  ontologyData: any;
  isAddOntologyMasterLoading: boolean;
  isAddOntologyMasterSuccess: boolean;
  addedItems: any;
  ontologyMgmntData: Array<any>;
  levelMasterData: Array<any>;
  isAddOntologyMasterFailed: boolean;
  ontologyMessage: string;
  ontologyMgmntDataHasError: boolean;
  isUpdateOntologyMasterSuccess: boolean;
  isUpdateOntologyMasterFailed: boolean;
}

const OntologyManagement = ({
  isOntologyDataLoading,
  ontologyData,
  isAddOntologyMasterLoading,
  isAddOntologyMasterSuccess,
  levelMasterData,
  isAddOntologyMasterFailed,
  ontologyMessage,
  ontologyMgmntDataHasError,
  isUpdateOntologyMasterSuccess,
  isUpdateOntologyMasterFailed,
  addedItems,
}: OntologyLevelTypes) => {
  const theme:any = useTheme();    
  const responsiveSize =  useMediaQuery('(min-width: 1200px)');
  const dispatch = useDispatch();
  const [cardPalette, setCardPalette] = useState<any[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);  
  const [levelMaster, setLevelMaster] = useState<any>([]);
  const [selectedData, setSelectedData] = useState<any>({});
  const [isOpen, setIsOpen] = useState(false);
  const [msg, sendNotification] = useNotification();
  const [isEdit, setIsEdit] = useState<Boolean>(false);
  const [newLevel, setNewLevel] = useState<any>({
    onto_level_number: null,
    onto_level_id: null,
    onto_manage_title: '',
    parent_id: null,
  });



  useEffect(() => {
    const colors = chroma.scale([theme.palette.primary.main, chroma(theme.palette.primary.main).set('hsl.h', '+180')])
      .mode('lch')
      .colors(6)
      .map((color: any, index: any) => ({
        primaryColor: color,
      }));
    setCardPalette(colors);
  }, [theme.palette.primary.main]);

  useEffect(() => {
    dispatch(ontologyMasterActions.setCurrentLevelMaster([]));
    dispatch(ontologyMasterActions.getOntologyList(''));
    setIsModalOpen(false);
  }, []);

  useEffect(() => {
    if (isAddOntologyMasterSuccess) {
      sendNotification({
        msg: ontologyMessage,
        variant: 'success',
        dispatchAction: ontologyMasterActions.resetLoadingState(),
      });
      dispatch(ontologyMasterActions.getOntologyList(''));
    }

    if (isAddOntologyMasterFailed || ontologyMgmntDataHasError || isUpdateOntologyMasterFailed) {
      sendNotification({
        msg: ontologyMessage,
        variant: 'error',
        dispatchAction: ontologyMasterActions.resetLoadingState(),
      });
    }

    if (isUpdateOntologyMasterSuccess) {
      sendNotification({
        msg: ontologyMessage,
        variant: 'success',
        dispatchAction: ontologyMasterActions.resetLoadingState(),
      });
      dispatch(ontologyMasterActions.getOntologyList(''));
    }
  }, [
    isAddOntologyMasterSuccess,
    isAddOntologyMasterFailed,
    ontologyMgmntDataHasError,
    isUpdateOntologyMasterSuccess,
    isUpdateOntologyMasterFailed,
  ]);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
    setIsEdit(false);
  };

  const openModal = (items: any, type: String) => {
    let selectedLevels = [];
    selectedLevels = levelMaster.filter((item: any) => {
      return item.level_number === items.level_number - 1;
    })[0];

    setSelectedData({
      level_number: items.level_number,
      level_name: items.level_name,
      level_id: items.id,
      parent_id: items.level_number == 1 ? 0 : selectedLevels.selectedId ?? selectedLevels.selectedLevel,
      onto_data:
        type === 'edit' ? (items.onto_manages || []).filter((d: any) => d.onto_manage_id === items.selectedLevel) : [],
      isEdit: type === 'edit' ? true : false,
    });

    if (items.level_number != 1 && (selectedLevels.selectedId === null || selectedLevels.selectedId === -1)) {
      sendNotification({ msg: 'Please select ' + selectedLevels.levelName, variant: 'error' });
      setIsModalOpen(false);
    } else {
      setIsModalOpen(true);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const onLevelChange = (value: any, levelNumber: any, newlyAddedOntoManage?: any, reqType?: any) => {
    let resetChildren: boolean = false;
    let isLevelSelected: boolean = false;
    if (reqType) {
      setSelectedData({});
    }
    const modifiedOntoLevels = levelMaster.reduce((acc: any, level: any, i: any) => {
      if (level.level_number === levelNumber) {
        resetChildren = true;
        isLevelSelected = true;
        return [
          ...acc,
          {
            ...level,
            selectedLevel: value,
            onto_manages: reqType
              ? level.onto_manages.map((setdata: any) => {
                  if (setdata.onto_manage_id === newlyAddedOntoManage.onto_manage_id) {
                    return { ...setdata, onto_manage_title: newlyAddedOntoManage.onto_manage_title };
                  } else {
                    return { ...setdata };
                  }
                })
              : newlyAddedOntoManage
              ? [...get(level, 'onto_manages', []), newlyAddedOntoManage]
              : get(level, 'onto_manages', []),
          },
        ];
      }

      if (!reqType && i !== 0 && isLevelSelected) {
        const ontoLevel = ontologyData.find((originalLevel: any) => originalLevel.level_number === level.level_number);
        isLevelSelected = false;

        return [
          ...acc,
          {
            ...ontoLevel,
            onto_manages: ontoLevel.onto_manages.filter((onto: any) => acc[i - 1].selectedLevel === onto.parent_id),
            show: true,
          },
        ];
      }

      if (!reqType && resetChildren) {
        return [...acc, ontologyData.find((originalLevel: any) => originalLevel.level_number === level.level_number)];
      }

      return [...acc, level];
    }, []);

    setLevelMaster(modifiedOntoLevels);
  };

  useEffect(() => {
    if (ontologyData.length) {
      if (!levelMaster.length) {
        const modifiedOntoLevels = ontologyData.map((level: any, i: number) => {
          if (i === 0) {
            return {
              ...level,
              show: true,
            };
          }
          return level;
        });
        setLevelMaster(modifiedOntoLevels);
      } else {
        const newOnto = ontologyData.find((level: any) => level.level_number === newLevel.onto_level_number);
        const newOntoManages = get(newOnto, 'onto_manages', []);
        const filteredOntologyList = selectedData.isEdit
          ? newOntoManages.filter((item: any) => item.onto_manage_id === selectedData.onto_data[0]['onto_manage_id'])
          : [];
        const newlyAddedOntoManage = selectedData.isEdit
          ? filteredOntologyList.length
            ? filteredOntologyList[0]
            : []
          : newOntoManages[newOntoManages.length - 1];

        onLevelChange(
          get(addedItems, 'onto_manage_id'),
          newLevel.onto_level_number,
          addedItems,
          selectedData.isEdit ? selectedData.isEdit : false
        );
        setNewLevel({
          onto_level_number: null,
          onto_level_id: null,
          onto_manage_title: '',
          parent_id: null,
        });
      }
    }
  }, [JSON.stringify(ontologyData)]);
  const themeData:any = useTheme();
  const themeMode:any = get(useOutletContext(),'themeMode',{});

  return (
    <div>
      {isOntologyDataLoading ? (
        <CircularProgress />
      ) : (
        <>
          {!levelMaster.length ? (
            <Box textAlign={'center'}>
              <Typography variant='h2'>Ontology levels not found, Please add ontology levels...</Typography>
            </Box>
          ) : (
            <>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3, lg: 3 }} sx={{ marginTop: '0px', paddingRight: responsiveSize ? '8px' : 0 }}>
                {levelMaster.map((items: any, gridIndex: number) =>
                  items.show ? (
                    <Grid item sx={{paddingTop:'0px'}} key={items.level_number} xs={12} sm={12} md={6} lg={4} xl={3}>
                      <Card
                        sx={{
                          maxHeight: '190px',
                          padding: '32px',
                          borderRadius: '18px',
                          border: '0px 0px 4px 0px !important',
                          marginTop: '16px',
                          boxShadow: '0px 0px 14px 0px rgba(0, 0, 0, 0.05) !important',
                          backgroundColor: (themeMode.isLightBG) ? lighten(themeData.palette.background.default, 0.9) : lighten(themeData.palette.background.default, 0.05),
                          borderBottom: `4px solid ${get(cardPalette, `${[gridIndex % 6]}.primaryColor`, '')}`,
                          '@media (min-width:300px) and (max-width:899px)':{
                            marginTop: (gridIndex===0) ? '0px' : '16px',
                          }
                        }}
                      >
                        {items.onto_manages && items.onto_manages.length > 0 ? (
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'space-between',
                              alignItems: 'flex-start',
                              height: '130px',
                            }}
                          >
                            {' '}
                            <Box
                              sx={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'inherit',
                                alignItems: 'center',
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  alignItems: 'center',
                                  justifyContent: 'flex-start',
                                }}
                              >
                                <MapMakerIcon
                                  style={{
                                    marginRight: '12px',
                                    stroke: `${get(cardPalette, `${[gridIndex % 6]}.primaryColor`, '')}`,
                                    fill: `${get(cardPalette, `${[gridIndex % 6]}.primaryColor`, '')}`
                                  }}
                                />
                                <Typography
                                  sx={{
                                    color: `${get(cardPalette, `${[gridIndex % 6]}.primaryColor`, '')}`,
                                    fontSize: '1.5rem',
                                    fontWeight: '800',
                                    textTransform: 'uppercase',
                                  }}
                                >
                                  {items.level_name}
                                </Typography>
                              </div>
                              <div
                                style={{
                                  height: '24px',
                                  display: 'flex',
                                  flexDirection: 'row',
                                  alignItems: 'center',
                                  justifyContent: 'flex-end',
                                }}
                              >
                                {items.selectedLevel && (
                                  <>
                                    <EditButtonWithAccessCheck
                                      onClick={() => openModal(items, 'edit')}
                                      otherProps={{ levelName: items.level_name }}
                                    />
                                    <VerticalLine style={{ height: '24px', margin: '0 8px' , color: themeData.palette.customBorderColor.main }} />{' '}
                                  </>
                                )}
                                <AddButtonWithAccessCheck
                                  from='OntologyManagement'
                                  onClick={() => openModal(items, 'add')}
                                  otherProps={{ levelName: items.level_name }}
                                />
                              </div>
                            </Box>
                            <Box sx={Styles.content}>
                              <Select
                                name={items.level_name}
                                onOpen={handleOpen}
                                onClose={handleClose}
                                placeholder='Select'
                                label={'Select'}
                                IconComponent={() => isOpen ? (<ExpandLessIcon style={{ color: themeData.palette.custom.light }} />) : (<ExpandMoreIcon style={{ color: themeData.palette.custom.light}} />)}
                                onChange={(event: any) => {
                                  onLevelChange(event.target.value, items.level_number);
                                }}
                                variant='standard'
                                value={items.selectedLevel ?? -1}
                                fullWidth
                                sx={{
                                  width: '100%',
                                  padding: '9px 16px',
                                  textTransform:'capitalize',
                                  ':before': {
                                    borderBottom: `1px solid ${theme.palette.customBorderColor.main}`,
                                    '&:hover': {
                                      borderBottom: `1px solid ${theme.palette.customBorderColor.main} !important`,
                                    },
                                  },
                                  ':after': {
                                    borderBottom: `1px solid ${theme.palette.text.primary}`,
                                  },
                                  '.MuiSvgIcon-root': {
                                    marginRight: '5px',
                                  },
                                }}
                                renderValue={(selected) => {
                                  if (selected === -1 || selected === undefined || selected === null) {
                                    return <span style={{ fontStyle: 'italic',  color: '#c8c8ca' }}>Select {items.level_name.toLowerCase()}</span>;
                                  }
                                  const selectedOption = items['onto_manages']?.find((option: any) => option.onto_manage_id === selected);
                                  return selectedOption ? <span style={{ fontWeight: 'bold' }}>{selectedOption.onto_manage_title}</span> : '';
                                }}
                                inputProps={{
                                  MenuProps: {
                                    MenuListProps: {
                                      sx: {
                                        backgroundColor: 'white'
                                      }
                                    }
                                  }
                                }}
                              >
                                <MenuItem value={-1} sx={{ fontStyle: 'italic' }}>
                                  Select {items.level_name.toLowerCase()}
                                </MenuItem>
                                {items['onto_manages']
                                  .filter((item: any) => {
                                    return (
                                      item.parent_id === 0 ||
                                      levelMaster.find((level: any) => level.selectedLevel === item.parent_id)
                                    );
                                  })
                                  .map((option: any) => (
                                    <MenuItem key={option.onto_manage_id} value={option.onto_manage_id}>
                                      {option.onto_manage_title}
                                    </MenuItem>
                                  ))}
                              </Select>
                            </Box>
                          </div>
                        ) : (
                          <AddButtonWithAccessCheck
                            from='CardWithLabel'
                            onClick={() => openModal(items, 'add')}
                            otherProps={{
                              levelName:
                                items.level_name && items.level_name != '' ? 'Add ' + items.level_name : 'Add Level',
                            }}
                          />
                        )}
                      </Card>
                    </Grid>
                  ) : (
                    ''
                  )
                )}
              </Grid>
              {isModalOpen && (
                <AddLevels
                  title={
                    selectedData.isEdit
                      ? `Edit ${selectedData.level_name}`.toUpperCase()
                      : `Add ${selectedData.level_name}`.toUpperCase()
                  }
                  isOpen={isModalOpen}
                  levelMaster={levelMaster}
                  data={selectedData}
                  handleClose={closeModal}
                  isAddOntologyMasterLoading={isAddOntologyMasterLoading}
                  setNewLevel={setNewLevel}
                  isEdit={isEdit}
                />
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  ontologyData: state.ontologyMaster.ontologyData.slice().sort((a: any, b: any) => a.level_number - b.level_number),
  isOntologyDataLoading: state.ontologyMaster.isOntologyDataLoading,
  isAddOntologyMasterLoading: state.ontologyMaster.isAddOntologyMasterLoading,
  isAddOntologyMasterSuccess: state.ontologyMaster.isAddOntologyMasterSuccess,
  addedItems: state.ontologyMaster.addedItems,
  ontologyMgmntData: state.ontologyMaster.ontologyMgmntData,
  levelMasterData: state.ontologyMaster.levelMaster,
  isAddOntologyMasterFailed: state.ontologyMaster.isAddOntologyMasterFailed,
  ontologyMessage: state.ontologyMaster.ontologyMessage,
  ontologyMgmntDataHasError: state.ontologyMaster.ontologyMgmntDataHasError,
  isUpdateOntologyMasterSuccess: state.ontologyMaster.isUpdateOntologyMasterSuccess,
  isUpdateOntologyMasterFailed: state.ontologyMaster.isUpdateOntologyMasterFailed,
});

export default connect(mapStateToProps)(OntologyManagement);
